const cart = [
    {
        path: '/cart',
        name: 'cart',
        component: () => import('@/view/cart/Index'),
        meta: {
            requireAuth: true
        }
    }
]
export default cart